import {FC, ReactElement, useCallback, useState} from 'react';
import styled from 'styled-components';
import {sleep} from "utils/met";
import Message from "components/toasts/toasts";
import {useTranslation} from "react-i18next";
import {CopyToClipboard} from 'react-copy-to-clipboard'

const CheckDiv = styled.div`
  width: 100%;
  overflow: hidden;
  padding: 0.72rem 0 0.36rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-size: 100% 100%;
  min-height: 100%;
  font-size: 0.12rem;
  font-weight: 400;
  position: relative;
  color: #333333;

  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 0.6rem;
  }

  h1 {
    font-size: 0.18rem;
    padding: 0 0.12rem;
    font-weight: bold;
    line-height: 0.24rem;
    text-align: center;
    color: #08BDC7;
  }

  .card {
    width: 100%;
    margin-top: 0.32rem;
    margin-bottom: 0.18rem;
  }

  .bottom-div {
    position: absolute;
    bottom: 0.32rem;
  }

  .bottom_content {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.12rem;
    font-weight: 400;
    color: #08BDC7;
    margin-top: 0.08rem;

    p {
      margin: 0 0.08rem;
    }

    img {
      width: 0.16rem;
    }
  }


  .magnifier {
    height: 1.1rem;
    animation: spin-reverse 2s infinite linear;
  }

  .cirle-move {
    position: absolute;
    top: 2.1rem;
    right: 0.36rem;
    animation: spin 2s infinite linear;
    transform-origin: 0.64rem 0.64rem;
  }

  @keyframes spin {
    to {
      transform: rotate(1turn);
    }
  }

  @keyframes spin-reverse {
    to {
      transform: rotate(-1turn);
    }
  }
`;

const CompareVerifying: FC = (): ReactElement => {
    const {t} = useTranslation();
    const [messageVal, setMessageVal] = useState('')


    const copyUrlChange = useCallback(
        async (text, result) => {
            if (result) {
                setMessageVal(t('home.Copied'))
                await sleep(2000)
                setMessageVal('')
            }
        },
        [t]
    )
    return (
        <>
            <CheckDiv>
                <div className='title'>
                    <h1>{t('home.verified')}</h1>
                </div>
                <img className='card' src={require('img/card.png').default} alt=""/>
                <div className="cirle-move">
                    <img className="magnifier" src={require('img/card_loading.png').default} alt=""/>
                </div>

                <p style={{marginTop: '0.12rem',textAlign:'center',fontSize:'0.12rem',color:'#434347'}}>{t('home.youCheckLater')}</p>
                <div className='bottom-div'>
                    <p >{t('home.contactTelegram')}</p>
                    <CopyToClipboard text="https://t.me/Armonia_AMC" onCopy={copyUrlChange}>
                        <div className='bottom_content'>
                            <img src={require('img/icon_telegram.png').default} alt=""/>
                            <p>https://t.me/Armonia_AMC</p>
                            <img src={require('img/icon_copy.png').default} alt=""/>
                        </div>
                    </CopyToClipboard>
                </div>
            </CheckDiv>

            {messageVal && <Message content={messageVal}/>}
        </>
    );
}
;

export default CompareVerifying;
